import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { appStorage } from '@sternum/web/services/appStorage';

export interface DeviceState {
  isDeviceFiltersSidebarOpen: boolean;
  isPollingDevices: boolean;
}

const getInitialState: () => DeviceState = () => {
  return {
    isDeviceFiltersSidebarOpen: appStorage.device.getIsDeviceFiltersSidebarOpen() ?? true,
    isPollingDevices: false,
  };
};

export const deviceSlice = createSlice({
  name: 'devices',
  initialState: getInitialState,
  reducers: {
    clearDeviceStateAction() {
      return getInitialState();
    },

    setIsDeviceFiltersSidebarOpenAction(state, action: PayloadAction<boolean>) {
      state.isDeviceFiltersSidebarOpen = action.payload;
    },

    toggleIsDeviceFiltersSidebarOpenAction(state) {
      state.isDeviceFiltersSidebarOpen = !state.isDeviceFiltersSidebarOpen;
    },
  },
});

export const { clearDeviceStateAction, setIsDeviceFiltersSidebarOpenAction, toggleIsDeviceFiltersSidebarOpenAction } =
  deviceSlice.actions;
